// extracted by mini-css-extract-plugin
export default {"container":"styles_container__b3prf","spinnerContainer":"styles_spinnerContainer__VcGjB","hide":"styles_hide__q4d9t","cancelUpload":"styles_cancelUpload__S3MOi"};